import styles from './IntroCard.module.scss'

interface Props {
  icon: React.ElementType
  title: string
  description: string
}

const IntroCard = ({ icon: CardIcon, title, description }: Props) => (
  <div className={styles.IntroCard}>
    <div className={styles.icon}>
      <CardIcon />
    </div>
    <div className={styles.title}>{title}</div>
    <div className={styles.description}>{description}</div>
  </div>
)

export default IntroCard
